export { SimpleEarn, ConfigurationSimpleEarn } from './simple-earn';
export * as SimpleEarnRestAPI from './rest-api';

export {
    SIMPLE_EARN_REST_API_PROD_URL,
    ConnectorClientError,
    RequiredError,
    UnauthorizedError,
    ForbiddenError,
    TooManyRequestsError,
    RateLimitBanError,
    ServerError,
    NetworkError,
    NotFoundError,
    BadRequestError,
} from '@binance/common';
